var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('div',{staticClass:"container-fluid p-4"},[_c('quick-access-cards'),_c('slider-container'),_c('featured-cards')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }